// removed by extract-text-webpack-plugin
module.exports = {"testimonialCardContainer":"testimonialCardContainer__2M4Uy","testimonialContainer":"testimonialContainer__1nbux","innerContainer":"innerContainer__2akdJ","testimonialHeading":"testimonialHeading__2AvHj","moreTestimonialsContainer":"moreTestimonialsContainer__1SkWA","moreTestimonials":"moreTestimonials__azKVN"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVC/testimonials/style.css
// module id = h7Lh
// module chunks = 446